import { type ReactElement } from 'react';
import { ArrowLeft2, ArrowRight2, Cross } from '@/components/icons';
import { SidebarBrandIcon, SidebarBrandLogo } from '@/components/sidebar/SidebarBrandLogo';
import { Button } from '@/components/ui/button';
import { SidebarHeader, useSidebar } from '@/components/ui/sidebar';

export default function SidebarHeaderContent(): ReactElement {
    const { isMobile, state, toggleSidebar } = useSidebar();

    return (
        <SidebarHeader className="relative border-b border-border p-4 group-data-[collapsible=icon]:p-3">
            <div className="flex w-full items-center gap-3">
                <div className="flex min-w-0 flex-1 items-center gap-3 group-data-[collapsible=icon]:justify-center">
                    {isMobile || state === 'expanded' ? <SidebarBrandLogo /> : <SidebarBrandIcon />}
                </div>
            </div>
            <Button
                variant="ghost"
                size="icon"
                onClick={toggleSidebar}
                className="absolute right-4 top-1/2 z-20 size-10 -translate-y-1/2 hover:bg-muted group-data-[collapsible=icon]:left-full group-data-[collapsible=icon]:right-auto group-data-[collapsible=icon]:-ml-2 group-data-[collapsible=icon]:border-none group-data-[collapsible=icon]:bg-surface group-data-[collapsible=icon]:shadow-none group-data-[collapsible=icon]:hover:bg-muted"
            >
                {isMobile ? (
                    <Cross className="size-4" />
                ) : state === 'expanded' ? (
                    <ArrowLeft2 className="size-4" />
                ) : (
                    <ArrowRight2 className="size-4" />
                )}
            </Button>
        </SidebarHeader>
    );
}
